/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable no-unused-vars */
import React from "react";
import {
  Container,
  Row,
  Col,
  Spinner,
  Alert,
  Modal,
  Button,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInfoCircle,
  faListDots,
  faQuestion,
  faClock,
  faAngleLeft,
  faL,
} from "@fortawesome/free-solid-svg-icons";
import "./NewInterviewKit.scss";
import useAssignedInterviewKit from "./useAssignedInterviewKit";
import MainLayout from "../../Common/MainLayout";
export default (props) => {
  const {
    loading,
    loadingError,
    interviewKit,
    isDeclineAssessmentModal,
    resumeUploadModal,
    isResumeLoading,
    pdfError,
    resumeModalClick,
    onResumeUpload,
    onPracticeClick,
    onStartClick,
    onSubmitClick,
    onAcceptAssessmentKitClick,
    handleIsDeclineAssessmentModal,
    onNavigateBack,
  } = useAssignedInterviewKit(props);
  const user = JSON.parse(localStorage.getItem("jigsawUser"));
  return (
    <MainLayout
      pageName={"Assigned Interview Kit"}
      className="pb-5 create-interview-overview"
    >
      <div>
        <Container>
          <p
            className="text-primary mt-2 pb-2 mr-4 cursor-pointer font-weight-medium"
            onClick={onNavigateBack}
          >
            <FontAwesomeIcon icon={faAngleLeft} className="mr-2" />
            Back
          </p>
          <Row className="justify-content-center">
            {loading ? (
              <Spinner animation="border" variant="primary" />
            ) : (
              <Col className="col-md-12">
                {Array.isArray(loadingError) &&
                loadingError &&
                loadingError.length > 0 ? (
                  <div className="col-6">
                    <p className="font-weight-bold">
                      Oops something went wrong.
                    </p>
                    <p className="font-weight-bold">{loadingError}</p>
                  </div>
                ) : (
                  <>
                    <div className="border rounded-lg mb-3 p-4">
                      <h2 className="mb-3">
                        Proving Your Skills - Time for the Assessment Challenge!
                      </h2>
                      <div className="text-grey-4">
                        You're one step closer to joining our team. Showcase
                        your talents and stand out.
                      </div>
                    </div>
                    <div className="border rounded-lg p-4">
                      <div className="d-flex justify-content-between align-items-start">
                        <div className="d-flex align-items-start mb-4">
                          <div className="border-radius-10 mr-3">
                            <img
                              src={
                                "/assets/images/company-logo-placeholder.png"
                              }
                              alt="company-logo"
                              style={{ width: 50, height: 50 }}
                            />
                          </div>
                          <div className="info ml-3">
                            <p className="text-primary mb-1 font-weight-medium">
                              {interviewKit?.title}
                            </p>
                            <p className="text-grey-4">
                              {interviewKit?.job_detail &&
                                interviewKit.job_detail?.title}{" "}
                              {interviewKit?.job_detail && interviewKit.job_detail?.posted_by_details &&
                              interviewKit.job_detail.posted_by_details?.company_details && interviewKit.job_detail.posted_by_details.company_details?.name
                                ? `@ ${interviewKit?.job_detail && interviewKit.job_detail?.posted_by_details &&
                                  interviewKit.job_detail.posted_by_details?.company_details && interviewKit.job_detail.posted_by_details.company_details?.name}`
                                : null}
                            </p>
                          </div>
                        </div>

                        <div className="alert alert-primary fs-smallest border-0 py-1 d-inline-block">
                          SUBMIT BY: {interviewKit?.due_date}
                        </div>
                      </div>
                      <div className=" text-grey-4">
                        <p
                          className="d-inline-block pr-2"
                          dangerouslySetInnerHTML={{
                            __html: interviewKit?.epilogue_outro_note,
                          }}
                        ></p>
                        <p>{user?.user && user.user?.full_name},</p>
                        <p>
                          We are excited to inform you that you have been
                          assigned an assessment kit for{" "}
                          <span className="text-dark font-weight-medium">
                            “{interviewKit?.title}”
                          </span>{" "}
                          job role at{" "}
                          <span className="text-dark font-weight-medium">
                            “Zydelo”
                          </span>{" "}
                          through Jigsaw, a leading recruitment platform that is
                          revolutionizing the hiring process.
                        </p>
                        <p className="pt-2">
                          {" "}
                          Your qualifications and experience have caught our
                          attention, and we believe you could be a great fit for
                          our team. To take the next step, please follow the
                          steps below to access the assessment kit and begin the
                          journey to potentially joining our dynamic workforce.
                        </p>
                        <p className="mt-4 mb-1"> Warm Wishes,</p>
                        <p>
                          {interviewKit?.created_by_details &&
                            interviewKit.created_by_details?.full_name}
                        </p>

                        {/* <div className="text-grey-4">
                          {interviewKit?.welcome_note !== null ? (
                            <div
                              dangerouslySetInnerHTML={{
                                __html: interviewKit?.welcome_note,
                              }}
                            ></div>
                          ) : null}

                          <div
                          dangerouslySetInnerHTML={{
                            __html: interviewKit?.epilogue_outro_note,
                          }}
                          className="mt-4"
                        ></div>
                        </div> */}

                        <div className="py-4 text-grey-4 d-flex">
                          <div className="d-flex align-items-center mr-5">
                            <FontAwesomeIcon
                              icon={faListDots}
                              className="fs-smallest mr-3 fa-2x text-primary bg-light-blue rounded-lg p-3"
                            />
                            <div className="d-flex flex-column">
                              <h3 className="text-primary mb-1">
                                {Array.isArray(interviewKit?.topics) &&
                                  interviewKit?.topics &&
                                  interviewKit.topics.length}
                              </h3>
                              <p className="mb-0">Topics</p>
                            </div>
                          </div>
                          <div className="d-flex align-items-center mr-5">
                            <FontAwesomeIcon
                              icon={faQuestion}
                              className="fs-smallest mr-3 fa-2x text-primary bg-light-blue rounded-lg p-3"
                            />
                            <div className="d-flex flex-column">
                              <h3 className="text-primary mb-1">
                                {interviewKit?.total_question}
                              </h3>
                              <p className="mb-0">Questions</p>
                            </div>
                          </div>
                          <div className="d-flex align-items-center mr-4">
                            <FontAwesomeIcon
                              icon={faClock}
                              className="fs-smallest mr-3 fa-2x text-primary bg-light-blue rounded-lg p-3"
                            />
                            <div className="d-flex flex-column">
                              <h3 className="text-primary mb-1">
                                {interviewKit?.total_time} mins
                              </h3>
                              <p className="mb-0">Estimated time</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="border rounded-lg p-4  mt-3">
                      <h3 className="mb-3 font-weight-medium">
                        Topics to be prepared:
                      </h3>
                      <ul className="bullets text-grey-4 pl-3">
                        {Array.isArray(interviewKit?.topics) &&
                          interviewKit.topics.map((item) => (
                            <li className="text-capitalize">{item?.name}</li>
                          ))}
                      </ul>
                    </div>

                    <div className="border rounded-lg p-4  mt-3">
                      <h3 className="mb-3 font-weight-medium">
                        How to get started!
                      </h3>
                      <ul className="bullets text-grey-4 mb-4 pl-3">
                        <li className="mb-2">
                          Ensure you have a stable network connection to avoid
                          interruptions during the assessment.
                        </li>
                        <li className="mb-2">
                          {" "}
                          Select a quiet environment with no background noise
                          and a clear background for the assessment.
                        </li>
                        <li className="mb-2">
                          Each question in the assessment kit will have a
                          specified time limit to answer.
                        </li>
                        <li className="mb-2">
                          Submit the assessment before the specified end date.
                        </li>
                        <li className="mb-2">
                          Click the "Submit" button to finalize the submission.
                        </li>
                      </ul>
                      {interviewKit?.is_declined ? (
                        <div className="actions">
                          <Alert variant={"primary"}>
                            <FontAwesomeIcon
                              icon={faInfoCircle}
                              className="mr-2"
                            />
                            You have declined this Assessment Interview kit.
                          </Alert>
                        </div>
                      ) : (
                        <>
                          {interviewKit?.is_accepted ? (
                            <>
                              {interviewKit?.is_submit ? (
                                <div className="actions d-flex align-items-center">
                                  <p>Already completed?</p>
                                  <button
                                    className="btn btn-primary border ml-4"
                                    onClick={() => onSubmitClick()}
                                  >
                                    Submit Interview
                                  </button>
                                </div>
                              ) : (
                                <div className="actions d-flex align-items-center">
                                  {interviewKit?.answered_questions && (
                                    <p>
                                      {interviewKit?.answered_questions}{" "}
                                      Questions left.
                                    </p>
                                  )}

                                  {interviewKit?.answered_questions_count ===
                                  interviewKit?.total_questions ? (
                                    <button
                                      className="btn btn-primary"
                                      onClick={onSubmitClick}
                                    >
                                      Submit
                                    </button>
                                  ) : interviewKit?.answered_questions_count ===
                                    0 ? (
                                    <>
                                      <button
                                        className="btn btn-light border"
                                        onClick={() => onPracticeClick()}
                                      >
                                        Let’s practice first
                                      </button>
                                      <button
                                        className="btn btn-primary ml-4"
                                        onClick={() => onStartClick()}
                                      >
                                        I’m ready, let’s start
                                      </button>
                                    </>
                                  ) : (
                                    <button
                                      className="btn btn-primary"
                                      onClick={() => onStartClick()}
                                    >
                                      I’m ready, let’s start
                                    </button>
                                  )}
                                </div>
                              )}
                            </>
                          ) : (
                            <div className="actions d-flex align-items-center">
                              <button
                                className="btn btn-primary"
                                onClick={() => onAcceptAssessmentKitClick(true)}
                              >
                                Accept
                              </button>
                              <button
                                className="btn btn-light border ml-4"
                                onClick={() => handleIsDeclineAssessmentModal()}
                              >
                                Decline
                              </button>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </>
                )}
              </Col>
            )}
          </Row>
        </Container>

        <Modal
          show={isDeclineAssessmentModal}
          centered
          size="md"
          onHide={handleIsDeclineAssessmentModal}
          className="common-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <h3>Reject Assessment</h3>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-3 bg-white d-flex align-items-center justify-content-center flex-column">
            <h4>Are you sure you want to reject this Assessment?</h4>

            <div className="action mt-4">
              <button
                className="btn btn-primary px-5"
                onClick={() => onAcceptAssessmentKitClick(false)}
              >
                Yes
              </button>
              <button
                className="btn btn-dark ml-4 px-5"
                onClick={() => handleIsDeclineAssessmentModal()}
              >
                Cancel
              </button>
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          centered
          show={resumeUploadModal}
          onHide={() => resumeModalClick(false)}
        >
          <Modal.Header closeButton>
            <Modal.Title>{interviewKit?.title} </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="rounded-lg shadow-sm border">
              {/* details */}
              <div className="job-detail mb-3 px-3">
                <div className="row">
                  {/* {fieldsShown?.resume && ( */}
                  <div className="col-md-12">
                    <p className="font-weight-medium">
                      <span className="text-danger"> *</span>Resume{" "}
                    </p>

                    <>
                      {isResumeLoading ? (
                        <Spinner animation="border" variant="primary" />
                      ) : (
                        <input
                          className="form-control bg-transparent h-auto"
                          type="file"
                          name="resume"
                          accept=".pdf"
                          onChange={onResumeUpload}
                        />
                      )}
                    </>
                    {pdfError ? (
                      <p className="text-danger">
                        Please upload only pdf files!{" "}
                      </p>
                    ) : null}
                  </div>
                  {/* )} */}
                </div>
              </div>
              <Button
                variant=""
                onClick={() => resumeModalClick(false)}
                className="btn btn-dark mx-3 mb-3"
              >
                Close
              </Button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </MainLayout>
  );
};
